import CryptoJS from 'crypto-js'

const WALLET = 'wallet'
const TC_POLICY = 'tc_policy'
const POLICY_ACCEPTED = 'policy_accepted'

class LocalStorage {
  
  encryptAndStoreWallet(wallet, password) {
    const data = wallet
    const encryptedAES = CryptoJS.AES.encrypt(JSON.stringify(data), password)
    const localStorageObject = {
      address : wallet.address,
      encrypted : encryptedAES.toString()
    }
    localStorage.setItem(WALLET, JSON.stringify(localStorageObject))
    return localStorageObject
  }

  getWallet() {
    const wallet = localStorage.getItem(WALLET)
    if (wallet) {
      return JSON.parse(wallet)
    }
    return null
  }

  acceptTC() {
    localStorage.setItem(TC_POLICY, POLICY_ACCEPTED)
  }

  getTCPolicy() {
    const policyAccepted = localStorage.getItem(TC_POLICY)
    return {
      policy: policyAccepted ? true : false
    }
  }

}

const storage = new LocalStorage()

export default storage



// WEBPACK FOOTER //
// ./src/services/storage.js